import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import BackgroundMusicService from './services/BackgroundMusicService';
import ApiKeyService from './services/ApiKeyService';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ChatPage from './pages/ChatPage';
import ActivityPage from './pages/ActivityPage';
import RoutinePage from './pages/RoutinePage';
import AdminPage from './pages/AdminPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsUserPage from './pages/TermsUserPage';

function App() {
  const location = useLocation();
  const [backgroundMusicService] = useState(() => new BackgroundMusicService());
  const [isApiKeyInitialized, setIsApiKeyInitialized] = useState(false);

  // 앱 시작 시 API 키 초기화
  useEffect(() => {
    const initializeApiKeys = async () => {
      try {
        const apiKeyService = ApiKeyService.getInstance();
        await apiKeyService.initializeApiKeys();
        setIsApiKeyInitialized(true);
        console.log('API 키 초기화 완료');
      } catch (error) {
        console.error('API 키 초기화 실패:', error);
        // API 키 초기화 실패해도 앱은 계속 실행 (사용자에게 알림)
      }
    };

    initializeApiKeys();
  }, []);

  // 라우트 변경 시 배경음악 정지 (채팅 페이지가 아닌 경우)
  useEffect(() => {
    console.log('App.tsx: 라우트 변경 감지', location.pathname);
    if (location.pathname !== '/chat') {
      console.log('App.tsx: 채팅 페이지가 아니므로 음악 종료');
      backgroundMusicService.stopBackgroundMusic();
    } else {
      console.log('App.tsx: 채팅 페이지이므로 음악 유지');
    }
  }, [location.pathname, backgroundMusicService]);

  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="min-h-screen bg-background flex flex-col">
          <div className="fixed top-0 left-0 right-0 z-50">
            <Header />
          </div>
          <main className="pt-[110px] md:pt-20 flex-1">
            {!isApiKeyInitialized ? (
              <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-mint mx-auto mb-4"></div>
                  <p className="text-gray-600">API 키를 로드하는 중...</p>
                </div>
              </div>
            ) : (
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/activity" element={<ActivityPage />} />
                <Route path="/routine" element={<RoutinePage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsUserPage />} />
              </Routes>
            )}
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App; 